import { Row, Col, Card, Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { MapContainer, Marker, TileLayer } from 'react-leaflet'
import L from 'leaflet';
import icon from "../assets/mapIcon.png"
import phone from '../assets/Phone.svg'
import mail from '../assets/Mail.svg'
import pin from '../assets/Pin.svg'

const AboutUsCard = () => {
    const { t } = useTranslation()

    const aboutData = {
        id: 0,
        email: 'info@gemluxury.eu',
        phoneNumber: '+30 69 8314 5847',
        location: 'Σμύρνης 18, 68100 Νέα Χηλή '
    }

    const mapIcon = L.icon({ iconUrl: icon, iconSize: [30, 30], iconAnchor: [10, 25] });
    
    return (
        <Row className="d-flex justify-content-center mt-5" style={{backgroundColor: '#1E1E1E', paddingBottom: '2rem', marginBottom: '-10rem'}}>
            <Col xs={12} sm={12} md={5} lg={5}>
                <Card className="mt-2" style={{backgroundColor: 'transparent', border: 'none'}}>
                    <Card.Body>
                        <div className="roomNameWrapper">
                            <Row className="justify-content-center">
                                <Col xs={2} sm={1} md={2} lg={2} xl={1}>
                                    <Image src={phone} style={{color: '#595959', fontWeight: '400', height: '2rem', marginTop: '1rem', marginRight: '1rem'}} alt="AboutUsCardItemContactPhoneIcon"/>
                                </Col>
                                <Col xs={6} lg={10}>
                                    <h5 style={{color: '#fff', cursor: 'pointer', marginTop: '1rem'}} onClick={() => window.open(`tel:${aboutData.phoneNumber}`)}>{aboutData.phoneNumber}</h5>
                                </Col>
                            </Row>
                            <Row className="justify-content-center align-items-center">
                                <Col xs={2} sm={1} md={2} lg={2} xl={1}>
                                    <Image src={pin} style={{color: '#595959', fontWeight: '400', height: '2rem', marginTop: '1rem', marginRight: '1rem'}} alt="AboutUsCardItemContactLocation"/>
                                </Col>
                                <Col xs={6} lg={10}>
                                    <h5 style={{color: '#fff', cursor: 'pointer', marginTop: '1rem'}} onClick={() => window.open(`https://maps.app.goo.gl/Ve8qLWFz4q6trFPBA`)}>{aboutData.location}</h5>
                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col xs={2} sm={1} md={2} lg={2} xl={1}>
                                    <Image src={mail} style={{color: '#595959', fontWeight: '400', height: '2rem', marginTop: '1rem', marginRight: '1rem'}} alt="AboutUsCardItemContactEmailIcon"/>
                                </Col>
                                <Col xs={6} lg={10}>
                                    <h5 style={{color: '#fff', cursor: 'pointer', marginTop: '1rem'}} onClick={() => window.open(`https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=CllgCJZWxJkXvQZtWsQCgDKFNFnxTqrrMSqTxQwDPMDhcXKmNkWTStJNXMVVZBfMsVdlctcPvhg`, '_blank')}>{aboutData.email}</h5>
                                </Col>
                            </Row>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            
            <Col xs={12} sm={12} md={4} lg={4}>
                <Card className="bg-white shadow-sm md p-0 mt-2 mb-2">                    
                    <MapContainer 
                        center={[40.8542509,25.8269037]} 
                        zoom={15} 
                        scrollWheelZoom={false} 
                        style={{ width: '100%', height: '300px'}}
                    >
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={[40.8542509,25.8269037]} icon={mapIcon}/>
                    </MapContainer>
                </Card>
            </Col>
        </Row>
    )
}

export default AboutUsCard